<template>
  <div class="tree-view-item">
    <div v-if="isObject(data)" class="tree-view-item-leaf">
      <div @click.stop="toggleOpen()" class="tree-view-item-node">
        <span
          :class="{opened: isOpen()}"
          class="tree-view-item-key tree-view-item-key-with-chevron"
        >{{getKey(data)}}</span>
      </div>
      <tree-view-item
        :data="child"
        :key="index"
        v-show="isOpen()"
        :max-depth="maxDepth"
        :modifiable="modifiable"
        :keyString="getKey(data)"
        @change-data="onChangeData"
        v-for="(child,index) in data.children"
        :current-depth="currentDepth+1"
      />
    </div>
    <div v-if="isArray(data)" class="tree-view-item-leaf">
      <div class="tree-view-item-node" @click.stop="toggleOpen()">
        <span
          :class="{opened: isOpen()}"
          class="tree-view-item-key tree-view-item-key-with-chevron"
        >{{getKey(data)}}</span>
      </div>
      <tree-view-item
        :key="'c'+index"
        :data="child"
        v-show="isOpen()"
        :keyString="getKey(data)"
        :max-depth="maxDepth"
        :modifiable="modifiable"
        @change-data="onChangeData"
        :current-depth="currentDepth+1"
        v-for="(child,index) in data.children"
      />
    </div>
    <tree-view-item-value
      :data="data.value"
      v-if="isValue(data)"
      :modifiable="modifiable"
      :key-string="getKey(data)"
      class="tree-view-item-leaf"
      @change-data="onChangeData"
    />
  </div>
</template>

<script>
import TreeViewItemValue from "./TreeViewItemValue.vue";
import concat from "lodash/concat";

export default {
  name: "tree-view-item",
  components: { TreeViewItemValue },
  props: ["data", "max-depth", "current-depth", "modifiable"],
  data() {
    return {
      open: this.currentDepth < this.maxDepth
    };
  },

  methods: {
    isOpen() {
      return this.open;
    },
    toggleOpen() {
      this.open = !this.open;
    },

    isObject(value) {
      return value.type === "object";
    },
    isArray(value) {
      return value.type === "array";
    },
    isValue(value) {
      return value.type === "value";
    },
    getKey(value) {
      return value.key + ":";
    },
    isRootObject(value = this.data) {
      return value.isRoot;
    },
    onChangeData(path, value) {
      path = concat(this.data.key, path);
      this.$emit("change-data", path, value);
    }
  }
};
</script>

<style scoped>
.tree-view-item {
  font-size: 12px;
  margin-right: 18px;
}

.tree-view-item-node {
  cursor: pointer;
  position: relative;
  white-space: nowrap;
}

.tree-view-item-leaf {
  white-space: nowrap;
}

/* .tree-view-item-key {
  /* font-family: "IR_M"; */
/* } */

.tree-view-item-key-with-chevron {
  padding-right: 12px;
}

.tree-view-item-key-with-chevron::before {
  right: -3px;
  content: "+";
  color: #00897b;
  font-size: 14px;
  position: absolute;
  transition: transform 0.1s ease;
  transition: -webkit-transform 0.1s ease;
  -webkit-transition: -webkit-transform 0.1s ease;
  transition: transform 0.1s ease, -webkit-transform 0.1s ease;
}

.tree-view-item-key-with-chevron.opened::before {
  content: "-";
  color: #616161;
  font-size: 14px;
}

.tree-view-item-hint {
  color: #ccc;
}
</style>